import { useCallback } from 'react';

import { useExplorerConfig } from 'lib/contexts/ExplorerConfigContext';

/**
 * Pure utility function: replaces 'ERC' prefix with the given standard.
 * Works on strings like 'ERC-20', 'ERC-721', 'ERC-1155', 'ERC-404'.
 * Also handles lowercase and display text like "ERC-20 Tokens".
 */
export function formatTokenStandard(text: string, standard: string): string {
  if (!standard || standard === 'ERC') return text;
  // Replace ERC- prefix (case sensitive)
  return text.replace(/\bERC-/g, `${ standard }-`);
}

/**
 * React hook that returns a formatter function for token standard display.
 * Reads the configured token standard from admin settings.
 * Falls back to 'ERC' if not configured.
 */
export function useTokenStandard() {
  const { config } = useExplorerConfig();
  const standard = config?.network?.token_standard || 'ERC';

  const formatType = useCallback((text: string): string => {
    return formatTokenStandard(text, standard);
  }, [ standard ]);

  return { standard, formatType };
}



